<style>
#settings {
  height: 84px;
}
</style>

<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{suppressScrollY : true}"
    ref="bar-element"
  >
    <!-- <div class="group">
      <button
        class="ribbon-button"
        @click="show('legendModal')"
        title="Legenda mapy"
      >
        <span class="icon">
          <v-icon>layers</v-icon>
        </span>
        <span class="caption">WARSTWY</span>
      </button>
    </div> -->
    <div
      class="group"
      v-if="$can('read', 'settings_view')"
    >

      <div class="container__group--rows">
        <div class="ribbon__row border--bottom">
          <div
            class="ribbon-button ribbon__row--flex"
            @click="show('usersModal')"
          >
            <span class="icon">
              <v-icon small>person</v-icon>
            </span>
            <button class="caption">Użytkownicy</button>
          </div>
        </div>
        <div class="ribbon__row border--bottom">
          <div
            class="ribbon-button ribbon__row--flex"
            @click="show('loginSettingsModal')"
          >
            <span class="icon">
              <v-icon small>settings</v-icon>
            </span>
            <button class="caption">Ustawienia logowania</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="group"
      v-if="$can('read', 'settings_data_displaying')"
    >
      <button
        class="ribbon-button btn--large"
        @click="openSymbolization"
      >
        <span class="icon">
          <v-icon large>style</v-icon>
        </span>
        <span class="caption">Symbolizacja</span>
      </button>
    </div>
    <div
      class="group"
      v-if="$can('read', 'settings_data_displaying')"
    >
      <button
        class="ribbon-button btn--large"
        @click="show('dictionariesModal')"
      >
        <span class="icon">
          <v-icon large>library_books</v-icon>
        </span>
        <span class="caption">Słowniki</span>
      </button>
    </div>
    <div
      class="group"
      v-if="$can('read', 'settings_data_displaying')"
    >
      <button
        class="ribbon-button btn--large"
        @click="show('userAttributesModal')"
      >
        <span class="icon">
          <v-icon large>library_books</v-icon>
        </span>
        <span class="caption">Atrybuty użytkownika</span>
      </button>
    </div>
    <div
      class="group"
      v-if="$can('read', 'settings_history')"
    >
      <button
        class="ribbon-button btn--large"
        @click="show('HistoryChangesModal')"
      >
        <span class="icon">
          <v-icon large>restore</v-icon>
        </span>
        <span class="caption">Historia zmian</span>
      </button>
    </div>
    <div
      class="group"
      v-if="$can('read', 'settings_history')"
    >
      <button
        class="ribbon-button btn--large"
        title="Przeglądarka zdarzeń"
        @click="show('eventBrowserModal')"
      >
        <span class="icon">
          <v-icon large>ballot</v-icon>
        </span>
        <span class="caption">Zdarzenia</span>
      </button>
    </div>
    <div
      class="group"
      v-if="$can('read', 'settings_data_displaying')"
    >
      <button
        class="ribbon-button btn--large"
        @click="show('SharedViewModal')"
      >
        <span class="icon">
          <v-icon large>pageview</v-icon>
        </span>
        <span class="caption">Widoki</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button btn--large"
        @click="openDataImportModal"
      >
        <span class="icon">
          <v-icon large>arrow_downward</v-icon>
        </span>
        <span class="caption">Import danych</span>
      </button>
    </div>
    <div
      class="group"
      v-if="$can('read', 'settings_data_displaying')"
    >
      <button
        class="ribbon-button btn--large"
        @click="showSubserwisStatus"
        title="Sprawdź stan podpiętych baz danych"
      >
        <span class="icon">
          <v-icon large>extension</v-icon>
        </span>
        <span class="caption">Bazy danych</span>
      </button>
    </div>
    <div
      class="more-hidden"
      id="showMore"
    >
      <a href="#">
        <span class="fa fa-ellipsis-h"></span>
      </a>
      <ul class="hidden-menu"></ul>
    </div>
  </vue-custom-scrollbar>
</template>

<script>
// import CommonComp from "../../shared/CommonComp";
import vueCustomScrollbar from "vue-custom-scrollbar";
export default {
  components: {
    // CommonComp,
    vueCustomScrollbar
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    openSymbolization() {
      this.$root.$emit("changeAdminSymbolizationModal");
      this.show("legendModal");
    },
    openDataImportModal() {
      this.show("dataImportModal");
    },
    showSubserwisStatus() {
      this.$root.$emit("chackStatusSubService", true);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/settings/Settings.vue